// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
const CONFIRM_REQUEST = 'CONFIRM_REQUEST';
const CONFIRM_ORDER_FOR_CHARITY = 'CONFIRM_ORDER_FOR_CHARITY';
const CONFIRM_REQUEST_FAILED = 'CONFIRM_REQUEST_FAILED';

const CONFIRM_SET_MESSAGE = 'CONFIRM_SET_MESSAGE';
const SET_PAYMENT_TYPE = 'SET_PAYMENT_TYPE';

const SET_IS_COLLECTION_ARRANGED = 'SET_IS_COLLECTION_ARRANGED';

const SELECT_CHARITY_ID = 'SELECT_CHARITY_ID';

const GET_CHARITIES = 'GET_CHARITIES';
const GET_CHARITIES_SUCCESS = 'GET_CHARITIES_SUCCESS';


export {
  CONFIRM_REQUEST,
  CONFIRM_ORDER_FOR_CHARITY,
  CONFIRM_REQUEST_FAILED,

  CONFIRM_SET_MESSAGE,
  SET_PAYMENT_TYPE,

  SET_IS_COLLECTION_ARRANGED,

  SELECT_CHARITY_ID,

  GET_CHARITIES,
  GET_CHARITIES_SUCCESS,
};
